import React, { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import curebay from '../../assets/images/CBLogo.png';
import apiService from '../../services/apiservice';

const ApproveEnquiry = () => {
  const location = useLocation();
  const [urls, setUrls] = useState({ approve: '', reject: '' });
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const queryParams = new URLSearchParams(location.search);

  const enqId = queryParams.get('Id');
  const patientName = queryParams.get('patientName')?.replaceAll('_', ' ');
  const hospitalName = queryParams.get('hospitalName');
  const typeofSurgery = queryParams.get('typeofSurgery');
  const patientId = queryParams.get('patientId');
  const surgeryConfirmDate = queryParams.get('surgeryConfirmDate');
  const surgeryDescription = queryParams.get('surgeryDescription')?.replaceAll('_', ' ');

  useEffect(() => {
    if (!enqId) return;

    try {
      const encryptData1 = btoa(`${enqId}|A|F`);
      const encryptData2 = btoa(`${enqId}|R|F`);
      setUrls({ approve: encryptData1, reject: encryptData2 });
    } catch (error) {
      console.error('Error encoding data:', error);
    }
  }, [enqId]);

  const getApproval = useCallback(async (action) => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const url = action === 'A' ? urls.approve : urls.reject;
      const payload = { parameter1: url };
      const res = await apiService.patientReferalApproval(payload);
      setMessage(res?.data?.successObject?.message || 'Action completed');
    } catch (error) {
      console.error('Error in approval process:', error);
      setMessage('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  }, [urls, isLoading]);

  const formatSurgeryType = () => {
    let surgeryText = typeofSurgery || '';
    if (surgeryDescription && surgeryDescription !== 'null') {
      surgeryText += ` (${surgeryDescription})`;
    }
    return surgeryText;
  };

  if (message) {
    return (
      <div className="flex justify-center items-center w-full h-screen">
        <h1 className='text-xl font-bold'>{message}</h1>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center w-full h-screen">
      <div className="container">
        <div className="flex justify-center items-center h-full">
          <div className="w-full max-w-md mx-auto">
            <div className="mb-4 flex justify-start">
              <img src={curebay} alt="Curebay Logo" />
            </div>
            <div className="w-full">
              <p>Hi,</p>
              <p>We are referring the below patient to <strong>{hospitalName || 'N/A'}</strong> for the mentioned service. Please acknowledge.</p>
              <ul className='mt-4'>
                <strong>Patient ID:</strong> {patientId || 'N/A'}<br />
                <strong>Patient Name:</strong> {patientName || 'N/A'}<br />
                <strong>Surgery Type:</strong> {formatSurgeryType()}<br />
                <strong>Surgery Confirmed Date:</strong> {surgeryConfirmDate || 'N/A'}
              </ul>
              <p className='mt-4'>Do you accept to refer a patient to your hospital?</p>
            </div>
            <div className="flex items-center gap-4 mt-4">
              <button
                className={`btn bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                onClick={() => getApproval('A')}
                disabled={isLoading}
              >
                {isLoading ? 'Processing...' : 'Accept'}
              </button>
              <button
                className={`btn bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                onClick={() => getApproval('R')}
                disabled={isLoading}
              >
                {isLoading ? 'Processing...' : 'Reject'}
              </button>
            </div>
            <p className="mt-4">Thanks,<br />CureBay Support</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApproveEnquiry;